import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@/utils/utils";
import { Minus, Plus } from "lucide-react";
interface CounterProps {
  count: number;
  maxCount: number;
  onIncrement: () => void;
  onDecrement: () => void;
  classNames?: string;
  buttonClassNames?: string;
  countClassNames?: string;
  strokeWidth?: number;
  variant?: "solid" | "outlined";
  minCount?: number;
}
const Counter: React.FC<CounterProps> = t0 => {
  const $ = _c(31);
  const {
    count,
    maxCount,
    onIncrement,
    onDecrement,
    classNames: t1,
    buttonClassNames: t2,
    countClassNames: t3,
    strokeWidth: t4,
    variant: t5,
    minCount: t6
  } = t0;
  const classNames = t1 === undefined ? "" : t1;
  const buttonClassNames = t2 === undefined ? "" : t2;
  const countClassNames = t3 === undefined ? "" : t3;
  const strokeWidth = t4 === undefined ? 2.5 : t4;
  const variant = t5 === undefined ? "outlined" : t5;
  const minCount = t6 === undefined ? 1 : t6;
  const t7 = variant === "solid" ? "bg-[#037A6A]  text-white" : "border-[0.7px] md:border-[1px] border-[#037A6A]/50 md:border-[#037A6A] text-[#037A6A] bg-white";
  let t8;
  if ($[0] !== classNames || $[1] !== t7) {
    t8 = cn("flex justify-center items-center md:space-x-[6px] space-x-2 rounded-full md:py-[6px] py-1 md:text-lg text-base md:px-3 px-2 h-full", t7, classNames);
    $[0] = classNames;
    $[1] = t7;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== buttonClassNames) {
    t9 = cn("px-1 flex items-center justify-center transition-colors disabled:opacity-30", buttonClassNames);
    $[3] = buttonClassNames;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  const t10 = count <= minCount;
  let t11;
  if ($[5] !== strokeWidth) {
    t11 = <Minus size={18} strokeWidth={strokeWidth} />;
    $[5] = strokeWidth;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  if ($[7] !== onDecrement || $[8] !== t10 || $[9] !== t11 || $[10] !== t9) {
    t12 = <button onClick={onDecrement} className={t9} aria-label="Decrease count" disabled={t10}>{t11}</button>;
    $[7] = onDecrement;
    $[8] = t10;
    $[9] = t11;
    $[10] = t9;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== countClassNames) {
    t13 = cn("font-bold", countClassNames);
    $[12] = countClassNames;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== count || $[15] !== t13) {
    t14 = <div className={t13}>{count}</div>;
    $[14] = count;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== buttonClassNames) {
    t15 = cn("px-1 flex items-center justify-center transition-colors disabled:opacity-30", buttonClassNames);
    $[17] = buttonClassNames;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const t16 = count >= maxCount;
  let t17;
  if ($[19] !== strokeWidth) {
    t17 = <Plus size={18} strokeWidth={strokeWidth} />;
    $[19] = strokeWidth;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== onIncrement || $[22] !== t15 || $[23] !== t16 || $[24] !== t17) {
    t18 = <button onClick={onIncrement} className={t15} aria-label="Increase count" disabled={t16}>{t17}</button>;
    $[21] = onIncrement;
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t12 || $[27] !== t14 || $[28] !== t18 || $[29] !== t8) {
    t19 = <div className={t8}>{t12}{t14}{t18}</div>;
    $[26] = t12;
    $[27] = t14;
    $[28] = t18;
    $[29] = t8;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  return t19;
};
export default Counter;